import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';

export default function Navigation() {
  let {navigateTo, windowHeight, setInterfaceType} = useContext(BaseContext);

  return (
    <section className="section-icons" style={{ height: `${windowHeight}px` }}>
      <div>
        <i className="bi bi-person" onClick={() => navigateTo("profil")} ></i>
        <i className="bi bi-chat-square icon-active" onClick={() => navigateTo("contacts")}></i>
        <i className="bi bi-person-plus" onClick={() => { setInterfaceType("researchContact"); navigateTo("add-contact");}}></i>
      </div>

      <div>
        <i className="bi bi-gear"></i>
      </div>
    </section>
  );
}
